import React from 'react';
import {Button, Typography} from 'antd';
import type {NavigateFunction} from 'react-router-dom';
import type {ColumnsType} from 'antd/es/table';
import type {ProjectResponse} from '@/types';

const {Text} = Typography;

interface IProjectsColumnsArgs {
	navigate: NavigateFunction;
}

export function getProjectsTableColumns({
	navigate,
}: IProjectsColumnsArgs): ColumnsType<ProjectResponse> {
	return [
		{
			title: 'Название',
			dataIndex: 'name',
			key: 'name',
			render: (name: string, record: ProjectResponse) => {
				const path = `/projects/${record.id}`;

				return (
					<>
						<Button type="link" onClick={() => navigate(path)} style={{padding: 0}}>
							{name}
						</Button>
						{record.shared && (
							<Text type="secondary" style={{marginLeft: 8, fontSize: 12}}>
								(доступ по ссылке)
							</Text>
						)}
					</>
				);
			},
		},
		{
			title: 'Описание',
			dataIndex: 'description',
			key: 'description',
			ellipsis: true,
			render: (description: string | null) =>
				description
					? description.slice(0, 200) + (description.length > 200 ? '…' : '')
					: '—',
		},
		{
			title: 'Создан',
			dataIndex: 'createdAt',
			key: 'createdAt',
			width: 180,
			render: (createdAt: string) => new Date(createdAt).toLocaleString(),
		},
	];
}
